module.exports = __webpack_public_path__ + "static/media/collect-data-centralization-v2.74aad066.png";